// The fiscal year to stamp on a time entry, derived from the client and the
// entry's date.
//
// Mirrors Client.get_year_end_date (backend/clients/models.py:201) so the two
// agree, but returns just the YEAR: TimeEntry.year_end is an IntegerField
// holding a year, not a date.
//
// Derived on the frontend rather than the server so the value fills in visibly
// as you pick the client, instead of appearing after a save.

export function deriveYearEnd(client, dateISO) {
  if (!client || !dateISO) return null;

  const [y, m] = String(dateISO).split("-").map(Number);
  // Reject unparseable, infinite, or out-of-range values.
  // Number("") is 0, not NaN, so validate month is in valid range 1-12.
  if (!Number.isFinite(y) || !Number.isFinite(m) || m < 1 || m > 12) return null;

  // Personal, or corporate with no month end recorded: calendar year end.
  // The `!fiscal_month_end` half matches the server's own fallback.
  if (!client.is_corporate || !client.fiscal_month_end) return y;

  // Corporate: the fiscal year ends in this calendar year if the entry falls
  // on or before the month end, otherwise in the next one.
  return m <= Number(client.fiscal_month_end) ? y : y + 1;
}
